import React, { lazy } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';

const Home = lazy(() => import('./pages/Home'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Useterm = lazy(() => import('./pages/Useterm'));
const Goodsleep = lazy(() => import('./pages/Goodsleep'));
const Fxbot = lazy(() => import('./pages/Fxbot'));
const NotFound = lazy(() => import('./pages/NotFound'));

const App = () => (
  <Router>
    <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/privacy" element={<Privacy/>} />
        <Route path="/useterm" element={<Useterm/>} />
        <Route path="/goodsleep" element={<Goodsleep/>} />
        <Route path="/fxbot" element={<Fxbot/>} />
        <Route path="*" exact element={<NotFound/>} />
    </Routes>
  </Router>
);

export default App;
